export enum ProductTileScreenContainer {
  PRODUCT_TILE_SCREEN_CONTAINER_UNKNOWN = 'PRODUCT_TILE_SCREEN_CONTAINER_UNKNOWN',
  SEARCH_PRODUCT_RESULTS_PRIMARY_RESULTS = 'SEARCH_PRODUCT_RESULTS_PRIMARY_RESULTS',
  SEARCH_PRODUCT_RESULTS_SUGGESTED_BRAND_PRODUCTS = 'SEARCH_PRODUCT_RESULTS_SUGGESTED_BRAND_PRODUCTS',
  PRODUCT_PAGE_PRODUCTS = 'PRODUCT_PAGE_PRODUCTS',
  BRAND_PAGE_PRODUCTS = 'BRAND_PAGE_PRODUCTS',
  BRAND_PRODUCT_SEARCH_RESULTS_PRODUCTS = 'BRAND_PRODUCT_SEARCH_RESULTS_PRODUCTS',
  BRAND_PAGE_NEW_ARRIVALS_PRODUCTS = 'BRAND_PAGE_NEW_ARRIVALS_PRODUCTS',
  BRAND_PAGE_BUY_IT_AGAIN_PRODUCTS = 'BRAND_PAGE_BUY_IT_AGAIN_PRODUCTS',
  CATEGORY_PRODUCT_RESULTS_PRODUCTS = 'CATEGORY_PRODUCT_RESULTS_PRODUCTS',
  BOARDS_PAGE_SAVED_PRODUCTS = 'BOARDS_PAGE_SAVED_PRODUCTS',
  BUY_AGAIN_PAGE_PRODUCTS = 'BUY_AGAIN_PAGE_PRODUCTS',
  CHECKOUT_BRAND_PRODUCTS = 'CHECKOUT_BRAND_PRODUCTS',
  PRODUCT_BASED_COLLECTION_PRODUCTS = 'PRODUCT_BASED_COLLECTION_PRODUCTS',
  BRAND_VIDEO_LIBRARY_PRODUCTS = 'BRAND_VIDEO_LIBRARY_PRODUCTS',
  MY_BRANDS_PRODUCTS = 'MY_BRANDS_PRODUCTS',
  SEARCH_PRODUCT_RESULTS_RELATED_RESULTS = 'SEARCH_PRODUCT_RESULTS_RELATED_RESULTS',
  BRAND_PAGE_USER_JOURNEY = 'BRAND_PAGE_USER_JOURNEY',
  NEW_ARRIVALS_PAGE_PRODUCTS = 'NEW_ARRIVALS_PAGE_PRODUCTS',
  PRODUCT_PAGE_HEADER = 'PRODUCT_PAGE_HEADER',
  CART_PAGE_PRODUCTS = 'CART_PAGE_PRODUCTS',
  SIMILAR_PRODUCTS_PRODUCTS = 'SIMILAR_PRODUCTS_PRODUCTS',
  POST_ORDER_SIMILAR_BRANDS_PRODUCTS = 'POST_ORDER_SIMILAR_BRANDS_PRODUCTS',
  DIGEST_PAGE_PRODUCTS = 'DIGEST_PAGE_PRODUCTS',
  /**
   * @deprecated
   */
  BRAND_INSIGHTS_PAGE_BRAND_INSIGHTS_TILE = 'BRAND_INSIGHTS_PAGE_BRAND_INSIGHTS_TILE',
  REORDER_BRANDS_PAGE_BRAND_UPDATES_CAROUSEL = 'REORDER_BRANDS_PAGE_BRAND_UPDATES_CAROUSEL',
  REORDER_BRAND_PAGE_ALL_BRANDS_PRODUCTS = 'REORDER_BRAND_PAGE_ALL_BRANDS_PRODUCTS',
  FOLLOWED_BRANDS_PAGE_PRODUCTS = 'FOLLOWED_BRANDS_PAGE_PRODUCTS',
  BRAND_VIDEO_PLAYER_PAGE_PRODUCTS = 'BRAND_VIDEO_PLAYER_PAGE_PRODUCTS',
  BUNDLES_PAGE_PRODUCTS = 'BUNDLES_PAGE_PRODUCTS',
  BRAND_PAGE_SIDE_CART = 'BRAND_PAGE_SIDE_CART',
  PRODUCT_BASED_COLLECTION_SIDE_CART = 'PRODUCT_BASED_COLLECTION_SIDE_CART',
  PRODUCT_PAGE_SIDE_CART = 'PRODUCT_PAGE_SIDE_CART',
  SEARCH_PRODUCT_RESULTS_IRRELEVANCE_PRODUCTS = 'SEARCH_PRODUCT_RESULTS_IRRELEVANCE_PRODUCTS',
  BRAND_PAGE_BUY_IT_AGAIN_PRODUCTS_LIST = 'BRAND_PAGE_BUY_IT_AGAIN_PRODUCTS_LIST',
  BRAND_PAGE_BUY_IT_AGAIN_PRODUCTS_GRID = 'BRAND_PAGE_BUY_IT_AGAIN_PRODUCTS_GRID',
  EXCLUSIVITY_PRODUCTS = 'EXCLUSIVITY_PRODUCTS',
  MERCHANDISED_COLLECTIONS_PRODUCTS = 'MERCHANDISED_COLLECTIONS_PRODUCTS',
}
